// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Xx5jc","bigColWidth":"Table_bigColWidth__1jFWV","biggerColWidth":"Table_biggerColWidth__3DudB","row":"Table_row__1frDv","col":"Table_col__qM08u"};